export const b64toBlob = (b64Data, contentType = '') => {
  const sliceSize = 512;
  const parsedB64Data = b64Data.replace(/^[^,]+,/, '').replace(/\s/g, '');
  const byteCharacters = window.atob(parsedB64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
};

export const download = (file, filename) => {
  const link = document.createElement('a');
  link.href = URL.createObjectURL(file);
  link.download = filename;
  link.click();
  link.remove();
};
